import React from 'react'
import { Route } from 'react-router-dom'
import { usePermisosContext } from './permisos-context'
import RestrictedView from './RestrictedView'

const normalizeKeys = (permission, permissions) => {
  const bucket = []
  if (Array.isArray(permissions)) {
    permissions.forEach(key => {
      if (typeof key === 'string') bucket.push(key.trim().toLowerCase())
    })
  }
  if (typeof permission === 'string') {
    bucket.push(permission.trim().toLowerCase())
  }
  return bucket.filter(Boolean)
}

const PermissionRoute = ({ component: Component, permission, permissions, requireAll = false, ...rest }) => {
  const { permisos, usuario, loading } = usePermisosContext()
  const requiredKeys = normalizeKeys(permission, permissions)

  const hasSuperAdminAccess = () => {
    const tipo = Number(usuario?.tipo_usuario)
    return Number.isFinite(tipo) && tipo === 3
  }

  const hasPermission = () => {
    if (!requiredKeys.length) return true
    if (hasSuperAdminAccess()) return true
    if (!permisos || typeof permisos !== 'object') return false
    if (requireAll) {
      return requiredKeys.every(key => permisos[key])
    }
    return requiredKeys.some(key => permisos[key])
  }

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (loading) {
          return (
            <div className="permission-route__loading">
              Verificando permisos...
            </div>
          )
        }
        if (!hasPermission()) {
          return <RestrictedView />
        }
        return <Component {...routeProps} />
      }}
    />
  )
}

export default PermissionRoute
